import React, { memo } from 'react'
import { Autocomplete } from 'components/forms/autocomplete/DPLAutocomplete'
import { IShipperRate } from 'apps/rms/types/shipperRates'

interface IShipperProps {
  value: RecursivePartial<IShipperRate>
  onChange(change: RecursivePartial<IShipperRate>): void
  error?: string
}

export const Shipper = memo<IShipperProps>(({ error, onChange, value }) => {
  const { shipperApplication } = value || {}
  const { name } = shipperApplication || {}

  const updateShipperHandler = ({
    fullSelection,
    value: id,
  }: {
    value: string
    fullSelection?: { name: string }
  }) => {
    onChange({
      shipperApplication: {
        name: fullSelection?.name || undefined,
        id: id || undefined,
      },
    })
  }

  return (
    <div className='col-md-8 col-xs-4'>
      <Autocomplete
        label='Shipper'
        placeholder='Enter shipper name'
        value={name}
        onChange={updateShipperHandler}
        type='shipper'
        id='shipper-rates-shipper'
        dataTest='modal-shipper-name'
        required
        validationMessage={error}
      />
    </div>
  )
})
